import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import styles from './PremierPartnerGroupSingleSelect.module.scss';
import RequiredIndicator from '../../../RequiredIndicator';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const PremierPartnerGroupSingleSelect = ({
	options,
	handleChange,
	value,
	validationError,
}) => {
	return (
		<div className={styles.InputContainer}>
			<FormControl variant='filled' sx={{ width: '100%' }}>
				<InputLabel id={'dropdown-label-Premier-Partner-Group'}>
					<RequiredIndicator />
					Premier Partner Group
				</InputLabel>

				<Select
					labelId={'dropdown-label-Premier-Partner-Group'}
					id={'dropdown-Premier-Partner-Group'}
					name={'PremierPartnerGroup'}
					value={value}
					onChange={e => {
						handleChange(e);
					}}
					fullWidth={true}
				>
					<MenuItem value='' key={'dropdown-option--none'}>
						<em>None</em>
					</MenuItem>
					{options?.map(option => (
						<MenuItem
							value={option}
							key={'dropdown-option--' + option}
						>
							{option}
						</MenuItem>
					))}
				</Select>
				{validationError.errorMessage === null ||
				validationError.length > 0 ? (
					<div>
						<Alert
							severity='error'
							name='Premier Partner Group Error'
							sx={{
								borderStyle: 'solid',
								borderColor: 'black',
								borderWidth: 'thin',
								borderRadius: '4px',
							}}
						>
							<AlertTitle>Validation Notice</AlertTitle>
							<>Premier Partner Group must be selected</>
						</Alert>
					</div>
				) : null}
			</FormControl>
		</div>
	);
};

export default PremierPartnerGroupSingleSelect;
